var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg-icon',_vm._b({staticClass:"pkg-feather",attrs:{"data":_vm.sData,"outlined":"","stroke":"2"}},'svg-icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }